import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { SeasonalOverlays } from '../../seasonal';

const pageTitles: Record<string, string> = {
  '/': 'Dashboard',
  '/interpretations': 'Interpretaciones',
  '/test-data': 'Datos Pendientes',
  '/config': 'Configuración',
};

const SIDEBAR_COLLAPSED_KEY = 'medinterpret_sidebar_collapsed';

const Layout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false); // Mobile
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
    return saved === 'true';
  });
  const location = useLocation();

  // Close sidebar on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(sidebarCollapsed));
  }, [sidebarCollapsed]);

  const getPageTitle = (): string => {
    if (location.pathname.startsWith('/interpretations/')) {
      return 'Detalle de Interpretación';
    }
    return pageTitles[location.pathname] || 'MedInterpret';
  };

  const handleToggleCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className={`app-container ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <Sidebar
        isOpen={sidebarOpen}
        isCollapsed={sidebarCollapsed}
        onToggleCollapse={handleToggleCollapse}
      />

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay d-lg-none"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Adornos y efectos de temporada sobre toda la página (no reciben el puntero). */}
      <SeasonalOverlays />

      <main className="main-content">
        <Header
          title={getPageTitle()}
          onMenuClick={() => setSidebarOpen(!sidebarOpen)}
        />
        <div className="page-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
